import cn from 'classnames';
import { t } from 'i18n';
import React from 'react';
import ButtonGeneral from 'students/views/shared/components/ButtonGeneral';
import { styleInnerButton } from 'students/views/shared/components/ButtonGeneral/ButtonGeneral';
import CheckIcon from 'students/views/shared/components/CheckIcon';
import CrossIcon from 'students/views/shared/components/CrossIcon';
import styled from 'styled-components';

export interface ISelectAnswerPayload {
  value: boolean;
  itemId: number;
}

interface IProps {
  options: {
    itemId: number;
    statement: string;
    status: boolean | null;
  };
  onSelectAnswer: ({ value, itemId }: ISelectAnswerPayload) => void;
}

const StatementItem: React.FC<IProps> = ({ options, onSelectAnswer }) => {
  const { itemId, statement, status } = options;

  const handleSelectAnswer = (value: boolean) => {
    onSelectAnswer({
      value,
      itemId
    });
  };

  return (
    <SItemContainer dir="ltr">
      <STrueFalseQuestion>{statement}</STrueFalseQuestion>

      <SActionContainer>
        <SButton
          variant="light"
          className={cn({ selected: status === true })}
          onClick={() => handleSelectAnswer(true)}
          role="checkbox"
          aria-checked="true"
          aria-label={t('frontend.lesson_task.tasks.check.true_false.true')}
        >
          <CheckIcon color="#A3A2C0" />
        </SButton>

        <SButton
          variant="light"
          className={cn({ selected: status === false })}
          onClick={() => handleSelectAnswer(false)}
          role="checkbox"
          aria-checked="false"
          aria-label={t('frontend.lesson_task.tasks.check.true_false.false')}
        >
          <CrossIcon color="#A3A2C0" />
        </SButton>
      </SActionContainer>
    </SItemContainer>
  );
};

export default StatementItem;

export const SItemContainer = styled.div`
  font-family: var(--lingu-text-font-family);
  font-weight: 500;
  border-radius: 6px;
  background: #eeeef6;
  padding: 18px;
  margin-block-end: 16px;

  @media (min-width: ${({ theme }) => theme.linguBptMd}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const SActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-basis: 125px;
`;

export const STrueFalseQuestion = styled.div`
  margin-block-end: 16px;
  text-align: start;

  @media (min-width: ${({ theme }) => theme.linguBptMd}) {
    align-items: center;
    margin-block-end: 0;
    width: calc(100% - 100px);
    padding-inline-end: 1rem;
  }
`;

const SButton = styled(ButtonGeneral)`
  font-size: 1.5rem;
  border-radius: 10px;
  background: linear-gradient(180deg, #f5f5fa 0%, var(--color-white) 100%);
  box-shadow: 0 2px 0 #d6d6f1, inset 0 2px 0 var(--color-white);
  color: #a3a2c0;
  width: calc(50% - 10px);
  height: 3.25rem;

  ${styleInnerButton()} {
    padding: 0.5rem;
  }

  &.selected {
    background: linear-gradient(0deg, #25b6e5 6.9%, var(--color-blue) 94.83%);
    box-shadow: inset 0 2px 0 #44c6ee, inset 0 -2px 0 var(--color-blue-800);
    color: var(--color-white);

    svg {
      fill: white;
    }
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.linguBptMd}) {
    border-radius: 50%;
    width: 3.25rem;
  }
`;
